import {OutUnitMap} from '../constants';

export function GetUnitStringFromOutUnit(outUnitId: number): string {
	return OutUnitMap.get(outUnitId) || '';
}
